import { Stack, Typography } from "@mui/material";
import { PlaybookTitle } from "./PlaybookTitle";
import { H4Component } from "./H4Component";
import { LeadDetailsType } from "../../../../types";
import { TextBlock } from "./TextBlock";
import { getDateData } from "../../../../utils/getDateData";
import { useEffect } from "react";

export const LeadDetailsBlock = ({
  leadDetails,
  setTopic,
}: {
  leadDetails: LeadDetailsType;
  setTopic: (topic: string) => void;
}) => {
  const {
    name,
    title,
    company,
    linkedin,
    title_start_date,
    company_start_date,
    profile_description,
  } = leadDetails;

  const titleDates = getDateData(title_start_date);
  const companyDates = getDateData(company_start_date);

  const topic = "Prospect Details";

  useEffect(() => {
    setTopic(topic);
  }, [topic]);

  return (
    <Stack gap={"32px"} id={topic}>
      <PlaybookTitle text={topic} />
      <Stack gap={"16px"}>
        <Stack gap={"8px"}>
          <Typography
            sx={{
              color: "#024760",
              fontSize: "34px",
              fontWeight: 600,
              lineHeight: "44px",
            }}
          >
            {name}
          </Typography>
          <Typography
            sx={{
              color: "#464646",
              fontSize: "18px",
              lineHeight: "22px",
              fontWeight: 600,
            }}
          >
            {title}{" "}
            {titleDates && (
              <span
                style={{
                  color: "#797979",
                  fontSize: "16px",
                  lineHeight: "24px",
                  fontWeight: 400,
                }}
              >
                {`(${titleDates.fullYears > 0 ? titleDates.fullYears + "yrs " : ""}${titleDates.fullMonths ? `${titleDates.fullMonths}mos` : ""})`}
              </span>
            )}
          </Typography>
        </Stack>
        <Typography
          sx={{
            color: "#232323",
            fontSize: "16px",
            lineHeight: "24px",
            fontWeight: 500,
          }}
        >
          {company}{" "}
          {companyDates && (
            <span style={{ color: "#797979", fontWeight: 400 }}>
              {`since ${companyDates.monthNames} ${companyDates.year} (${companyDates.fullYears}yrs${companyDates.fullMonths ? ` ${companyDates.fullMonths}mos` : ""})`}
            </span>
          )}
        </Typography>

        {linkedin && (
          <Stack flexDirection={"row"} gap={"8px"} paddingTop={"8px"}>
            <H4Component text={"LinkedIn:"} color={"#005EAB"} />
            <a
              href={linkedin}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#0097DD", textDecoration: "underline" }}
            >
              {linkedin}
            </a>
          </Stack>
        )}
      </Stack>
      {profile_description && <TextBlock text={profile_description} />}
    </Stack>
  );
};
